import { Col, Divider, Row, Tabs, Typography } from 'antd';
import TitleTable from '../../Dashboard/components/TitleTable';
import { useRef, useState } from 'react';
import IntergrateShopee from './IntergrateShopee';
import Popup from '@root/core/components/Popup';

enum MarketingPlaceTabs {
  Shopee = 'Shopee',
  Amazon = 'Amazon',
  Lazada = 'Lazada'
}

interface ITabHeader {
  imageUrl: string;
  title: string;
  marketPlace: string;
}

const TabHeader = ({ imageUrl, title, marketPlace }: ITabHeader) => {
  return (
    <div className="custom-card ant-card marketing-place-item">
      <div className="flex justify-between align-center">
        <img src={imageUrl} alt={marketPlace} height={30} />
        <div className="flex ">
          <Typography.Text
            style={{
              color: 'rgba(0, 0, 0, 0.90)'
            }}
          >
            {title}
          </Typography.Text>
          <Typography.Text
            style={{
              color: '#C4C4C4'
            }}
          >
            &nbsp; | {marketPlace}
          </Typography.Text>
        </div>
      </div>
    </div>
  );
};

const MarketPlaceList = () => {
  const [activeTab, setActiveTab] = useState<MarketingPlaceTabs | ''>('');
  const [openModal, setOpenModal] = useState<boolean>(false);

  const handleTabChange = (key: MarketingPlaceTabs) => {
    setActiveTab(key);
    if (key !== MarketingPlaceTabs.Shopee) {
      setOpenModal(true);
    }
  };

  return (
    <>
      <Tabs
        activeKey={activeTab}
        onChange={(e) => handleTabChange(e as MarketingPlaceTabs)}
        className="custom-tab-button"
      >
        <Tabs.TabPane
          tab={
            <TabHeader
              imageUrl={'/images/shopee-icon.png'}
              title="쇼피"
              marketPlace={MarketingPlaceTabs.Shopee}
            />
          }
          key={MarketingPlaceTabs.Shopee}
        >
          <IntergrateShopee />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={
            <TabHeader
              imageUrl="/images/amazon-icon.png"
              title="아마존"
              marketPlace={MarketingPlaceTabs.Amazon}
            />
          }
          key={MarketingPlaceTabs.Amazon}
        ></Tabs.TabPane>
        <Tabs.TabPane
          tab={
            <TabHeader
              imageUrl="/images/lazada-icon.png"
              title="라자다"
              marketPlace={MarketingPlaceTabs.Lazada}
            />
          }
          key={MarketingPlaceTabs.Lazada}
        ></Tabs.TabPane>
      </Tabs>
      <Popup
        styleBackground="white"
        styleColor="#2A2D51"
        visible={openModal}
        hiddenCancelBtn={true}
        textOk="확인"
        title={'Coming soon'}
        action_oke={() => {
          setOpenModal(false);
        }}
      />
    </>
  );
};

const IntergrationContainer = () => {
  return (
    <div className="custom-card ant-card">
       <div className="busk-sellerSubHead">
        <Row align="middle">
          <Col flex="auto">
            <Typography.Text>연동 내역</Typography.Text>
          </Col>
        </Row>
      </div>
      <Divider style={{ margin: '0' }} />
      <MarketPlaceList />
    </div>
  );
};

export default IntergrationContainer;
